module.exports = __webpack_public_path__ + "static/media/lueddins.02bf9994.svg";